<div *ngIf="!isLoading">
  <div *ngIf="accounts.length > 0">

    <h2>Rekeningen</h2>
    <div *ngFor="let account of accounts; let i = id;"
         [routerLink]="(account.leefgeld ? '/leefgeldrekening/' : '/rekening/') + account.id"
         class="pointer rounded-indent extended full-width mb20">
      <div class="relative">
        {{account.accountCategory.name.toLowerCase()}}
        <span class="hover-nudge"
              style="position:relative; top: 7px; display: inline-block; height: 24px;"
              *ngIf="account.allowedToManuallyImport"
              (click)="openManualModal(account, $event)">
              <mat-icon>info_outline</mat-icon>
        </span>
      </div>
      <div>
        <strong>{{account.accountNumber}}</strong>
      </div>
      <div class="float-left hide-on-desktop">
        saldo:
        <strong>{{currencyService.symbol(account.currency)}}{{currencyService.format(account.saldo)}}</strong>
      </div>
      <div class="float-left hide-on-desktop">
        {{account.lastUpload}}
      </div>
      <div class="float-right relative hide-on-phone">
        <div class="hover-nudge remove">
          <mat-icon (click)="delete(account, $event)" *ngIf="!account.hasTransactions">delete</mat-icon>
        </div>
        <div *ngIf="account.unassignedTransactionCount > 0"
             class="badge ml14 float-right">
          {{account.unassignedTransactionCount}} transacties indelen
        </div>
      </div>
      <div class="clearFix"></div>
    </div>
  </div>
  <div *ngIf="accounts.length === 0">
    <h2>er zijn nog geen rekeningen ingevoerd</h2>
    lees banktransacties in om verder te gaan. klik op de onderstaande link.
  </div>
</div>
